import * as React from "react";
import { useTableKindId } from "../../newcomponents/table/data/useTableKindId";
import { useTableItemQueryData } from "../../newcomponents/table/data/useTableItemQueryData";
import { Table } from "../../newcomponents/table/table";
import { TableNewItemButton } from "../../newcomponents/table/components/tableNewButton";
import { TableHeaderRefreshButton } from "../../newcomponents/table/components/RefreshButton";
import { CustomTableCPLNQuery } from "../../newcomponents/table/components/TableCplnQuery";
import { NameDescriptionColumn } from "../../newcomponents/table/columns/wellKnown/nameDescriptionColumn";
import { TagsColumn } from "../../newcomponents/table/columns/wellKnown/tagsColumn";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { ServiceAccount } from "../../schema/types/serviceAccount/entity";
import { linksOf } from "../../services/cpln";
import { OriginColumn } from "../../newcomponents/table/columns/wellKnown/originColumn";
import { TableActionsDropdown } from "../../newcomponents/table/components/tableActionsDropdown";
import { DeleteModal } from "../../components/modals/deleteModal";
import { useColumnsWithTagColumns } from "../../newcomponents/table/columns/tagColumns/useColumnsWithTagColumns";
import { ServiceAccountTableItem } from "../../mst/kinds/serviceAccount.helpers";

export const ServiceAccountList: React.FC = () => {
  const [selectedLinks, setSelectedLinks] = React.useState<string[]>([]);
  const [action, setAction] = React.useState<string>("");

  const { kind, id } = useTableKindId("serviceaccount", "serviceaccount-list");
  const qData = useTableItemQueryData<ServiceAccount>(kind, {});
  const columns = useColumnsWithTagColumns<ServiceAccountTableItem>(
    [NameDescriptionColumn(), OriginColumn(), TagsColumn(), CreatedColumn(), LastModifiedColumn()],
    kind,
  );

  const serviceAccountTableItems: ServiceAccountTableItem[] = qData.visibleItems.map((item) => {
    const selfLink = linksOf(item).self!;
    return { ...item, selfLink: selfLink };
  });

  return (
    <>
      <Table<ServiceAccountTableItem>
        title={"Service Accounts"}
        data={serviceAccountTableItems}
        selectKey="selfLink"
        selectMode="multi"
        selections={selectedLinks}
        onSelectionsChange={setSelectedLinks}
        tableId={id}
        headerRenderer={() => {
          return (
            <>
              <TableNewItemButton kind={kind} />
              <TableActionsDropdown
                kind={kind}
                selectionLinks={selectedLinks}
                options={[
                  {
                    key: "delete",
                    label: "Delete",
                    disabled: selectedLinks.length < 1,
                    danger: true,
                    callback: () => setAction("delete"),
                  },
                ]}
              />
              <TableHeaderRefreshButton onClick={qData.refetch} />
              <CustomTableCPLNQuery
                tableId={id}
                kind={kind}
                onQuery={qData.setCplnQuery}
                isLoading={qData.isLoading}
              />
            </>
          );
        }}
        enableFilter
        isLoading={qData.isLoading}
        onSortChange={qData.setSort}
        onSearchChange={qData.setSearch}
        isLoadingMore={qData.isLoadingMore}
        hasMore={qData.hasMore}
        onLoadMore={qData.fetchNextPage}
        columns={columns}
      />
      {action === "delete" ? (
        <DeleteModal
          kind={kind}
          onCancel={() => setAction("")}
          onComplete={() => {
            setAction("");
            setSelectedLinks([]);
            qData.refetch();
          }}
          links={selectedLinks}
        />
      ) : null}
    </>
  );
};
